/** @format */

import { axiosInstance } from '@common/application/context/Providers';
import { AxiosApiResponse } from '@common/types/api';
import { ElasticQueryOpts, ElasticResponse, ElasticSearchAfter } from '@common/types/elastic';
import { Nullable } from '@common/types/utils';

export class About {
  id: number;
  block: string;
  locale: string;
  companyId: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;

  constructor(block: string, locale: string, companyId: number) {
    this.block = block;
    this.locale = locale;
    this.companyId = companyId;
  }

  static list(query, sort, queryOpts: ElasticQueryOpts, size?: number, pit?: Nullable<string>, search_after?: Nullable<ElasticSearchAfter>): ElasticResponse<About> {
    // Ensure this code is not ran by SSR!
    if (typeof window !== 'undefined') {
      return axiosInstance
        .get(`/api/v1/abouts`, {
          params: {
            sequence_id: 1,
            pit,
            query,
            queryOpts: JSON.stringify(queryOpts ?? { deleted: false }),
            sort: JSON.stringify(sort),
            search_after: JSON.stringify(search_after),
            size,
          },
        })
        .then((res) => ({ ...res.data }));
    }
    throw new Error();
  }

  static get(id: number): AxiosApiResponse<About> {
    return axiosInstance.get(`/api/v1/abouts/${id}`).then((res) => ({ ...res.data }));
  }

  static delete(id: number): Promise<Record<string, unknown>> {
    return axiosInstance.delete(`/api/v1/abouts/${id}`).then((res) => ({ ...res.data }));
  }

  static undelete(id: number): Promise<Record<string, unknown>> {
    return axiosInstance.post(`/api/v1/abouts/${id}/undelete`).then((res) => ({ ...res.data }));
  }

  static update(updatedAbout: { name: string; companyId: number; logo: string }, id: number): Promise<Record<string, unknown>> {
    return axiosInstance.patch(`/api/v1/abouts/${id}`, { payload: updatedAbout }).then((res) => ({ ...res.data }));
  }

  static getAddTemplate(): Promise<Record<string, unknown>> {
    return axiosInstance.get(`/api/v1/templates/abouts/add`, {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  add(): Promise<Record<string, unknown>> {
    return axiosInstance
      .post(`/api/v1/abouts`, {
        payload: {
          block: this.block,
          locale: this.locale,
          companyId: this.companyId,
        },
      })
      .then((res) => ({ ...res.data }));
  }
}
